import {Component, OnInit} from '@angular/core';
import {CommonModule, Location} from '@angular/common';
import { PrimeNGConfig } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { InMemoryCacheService } from './common/cache/in-memory-cache.service';
import { UtilsService } from './common';
import { LayoutService } from './layout/service/app.layout.service';
import { RouterOutlet } from '@angular/router';

@Component({
    standalone: true,
    selector: 'app-root',
    templateUrl: './app.component.html',
    imports:[
        CommonModule,
        RouterOutlet,
    ]
})
export class AppComponent implements OnInit{

    menuMode = 'horizontal';
    layout = 'purple';
    theme = 'purple';
    ripple: boolean;

    colorScheme = 'dark';

    constructor(private primengConfig: PrimeNGConfig, private translate: TranslateService, private cache: InMemoryCacheService,
        private location: Location, private utils: UtilsService, private layoutService: LayoutService) {
        this.translate.addLangs(['en']);
        this.translate.setDefaultLang('en');
        this.translate.use('en');
    }

    public async ngOnInit(): Promise<void> {
        this.primengConfig.ripple = true;
        this.ripple = true;

        this.cache.menuMode.subscribe((data) => {
            if (data) {
                this.utils.logger.info(`AppMenuComponent.ngOnInit() setting menu data ${data}`);
                this.layoutService.updateMenuMode(data);
            }
       });

        //giving a little time for routes to change before performing checks
        setTimeout(async () => {
            if (!this.location.path().split('?')[0].includes('account')) {
                const user = JSON.parse(localStorage.getItem('currentUser'));
                if (user) {
                    this.cache.loading = true;
                    try {
                        await this.cache.getClaimsAndUpdateMenu();
                    } catch {
                    } finally {
                        this.cache.loading = false;
                    }
                }
              //  this.layoutService.updateMenuMode('slim-plus');
            } else {
                this.cache.getMainMenu();
              //  this.layoutService.updateMenuMode('horizontal');
            }
        }, 400);


    }
}
